import React from "react";
import CharchaVideoSlider from "./CharchaVideoSlider";

const CharchaVideo = ({ video, handleShareData, type , sharetext}) => {
  return (
    <>
      <div className="container-fluid">
        <div className="episode_banner_pad_stick">
          <h3 className="charcha_head">
            Charcha pe Videos
            <sup>
              <img src="/assets/images/charchawing.svg" alt="" />
            </sup>
          </h3>
        </div>
      </div>

      <div className="charcha_slider">
        <CharchaVideoSlider
          video={video}
          handleShareData={handleShareData}
          type={type}
          sharetext={sharetext}
        />
      </div>
    </>
  );
};

export default CharchaVideo;
